import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {BehaviorSubject, firstValueFrom} from 'rxjs';
import {Notification, NotificationManagerResponse} from './connectionMessage';

@Injectable({
    providedIn: 'root'
})
export class NotificationConnectionService {

    private jwt: string | null = "";
    private jwtWSO: string | null = "";
    private apiUser: string = "";
    private notifications: NotificationManagerResponse | null = {
        code: 0,
        message: "",
        type: "",
        sinLeer: [],
        leidas: []
    };
    private socket: WebSocket | null = null;
    private reconnectInterval = 5000;
    showNotificationContentDialog: boolean = false;
    activePoint = new BehaviorSubject<boolean>(false)
    constructor(private http: HttpClient) {
        this.apiUser = environment.apiUser;
    }

    connectToWebsocket() {
        this.jwt = sessionStorage.getItem('ACCESS_TOKEN');
        this.jwtWSO = sessionStorage.getItem('ACCESS_TOKEN_WSO');
        if (this.jwt && this.jwtWSO) {
            if (this.socket) {
                this.socket.close();
            }
            this.socket = new WebSocket(`${environment.wsConnection}/api/user/ws/notifications`);
            this.socket.addEventListener("open", async (event) => {
                this.sendConnectionMessage();
                await this.getApiNotifications();
            });

            this.socket.addEventListener("message", async (event) => {
                try {
                    const wsdata = JSON.parse(event.data)
                    if (wsdata.idPersona) {
                        this.activePoint.next(true)
                        sessionStorage.setItem('notificationSeen','false')
                        await this.getApiNotifications()
                    }
                } catch (error) {
                    return;
                }
            });

            this.socket.addEventListener("error", (event) => {
                console.log("Error in server", event);
            });
            this.socket.addEventListener("close", (event) => {
                this.reconnect();
            });
        }
    }

    private sendConnectionMessage() {
        const connection = {
            messageType: 'CONNECT',
            jwt: this.jwt,
            authorizationBanca: this.jwtWSO
        };
        this.socket?.send(JSON.stringify(connection));
    }

    private reconnect() {
        setTimeout(() => {
            this.connectToWebsocket();
            this.validateNotifications();
        }, this.reconnectInterval);
    }

    sendPing() {
        this.jwt = sessionStorage.getItem('ACCESS_TOKEN');
        this.jwtWSO = sessionStorage.getItem('ACCESS_TOKEN_WSO');
        const testPing = {
            messageType: 'PING',
            jwt: this.jwt,
            authorizationBanca: this.jwtWSO
        };
        const stringifyInfoPing = JSON.stringify(testPing);
        setInterval(() => {
            if (this.socket && this.socket.readyState === WebSocket.OPEN) {
                this.socket.send(stringifyInfoPing);
            }
        }, 1000);
    }

    closeWebsocketConnection() {
        if (this.socket) {
            this.jwt = sessionStorage.getItem('ACCESS_TOKEN');
            this.jwtWSO = sessionStorage.getItem('ACCESS_TOKEN_WSO');

            const close = {
                messageType: 'CLOSE',
                jwt: this.jwt,
                authorizationBanca: this.jwtWSO
            };

            const closeStringify = JSON.stringify(close);
            this.socket.send(closeStringify);
            this.socket.close();
        }
    }

    async getApiNotifications(): Promise<any> {
        let res: NotificationManagerResponse;
        try {
            res = await firstValueFrom(this.http.get<NotificationManagerResponse>(`${this.apiUser}/notifications`));
        } catch (error) {
            console.log(error);
            return;
        }

        if (res) {
            try {
                res.leidas.forEach(x => {
                    x.contenido = this.getNotificationContent(x.contenido)
                });
                res.sinLeer.forEach(x => {
                    x.contenido = this.getNotificationContent(x.contenido)
                });
                res.sinLeer = res.sinLeer.sort((a, b) => a.msCreacion - b.msCreacion);
                this.notifications = res;
                return;
            } catch (error) {
                return;
            }
        }
    }

    deleteNotificationAPI(notificationId: number) {
        return this.http.get(`${this.apiUser}/notifications/delete/${notificationId}`);
    }

    getNotificationContent(stringContent) {
        try {
            return JSON.parse(stringContent)
        } catch (e) {
            return ""
        }
    }

    setReadNotificationApi(idNotification: number) {
        return this.http.get(`${this.apiUser}/notifications/update/${idNotification}`);
    }

    updateAllNotifications(action: String) {
        return this.http.get(`${this.apiUser}/notifications/action/${action}`);
    }

    getNoReadNotificationLength(): number {
        return this.notifications ? this.notifications.sinLeer.length : 0;
    }

    getReadNotificationLength(): number {
        return this.notifications ? this.notifications.leidas.length : 0;
    }

    getNoReadNotification(): Notification[] {
        return this.notifications ? this.notifications.sinLeer : [];
    }

    getReadNotification(): any[] {
        return this.notifications ? this.notifications.leidas : [];
    }

    validateNotifications(){
        const notificationsSeen = sessionStorage.getItem('notificationSeen');
            if( this.getNoReadNotificationLength() > 0 && notificationsSeen !== 'true'){
                this.activePoint.next(true)
                return  true;
            }else{
                this.activePoint.next(false)
                return false;
            }
    }
}
